// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__1CMns","text":"styles_text__13isI","subText":"styles_subText__eBb-T"};